import { setupMFEApps } from '../setupMFEApps'
  ;(async () => {
  await setupMFEApps()
  import('./bootstrap')
})()
